/**
 * GM Strategy Hub - Page Export
 * 
 * This is the entry point imported by App.tsx and GMFlowPage.tsx
 * Place this in: ui/src/pages/GMStrategyHub.jsx
 */

import React from 'react';
import { useParams } from 'react-router-dom';
import App from '../components/gm-strategy-hub-v22';

// Default export for: import GMStrategyHub from "./pages/GMStrategyHub"
export default function GMStrategyHub() {
  const { poolId } = useParams();
  return <App poolId={poolId} />;
}

// Named export for: import { GMStrategyHub } from "./pages/GMStrategyHub"
export { GMStrategyHub };
